import * as yup from "yup";
import { PhoneNumberUtil } from "google-libphonenumber";
const phoneUtil = PhoneNumberUtil.getInstance();
let createRunsheetValidationForm = yup.object().shape({
  vehicle: yup.string().required("Vehicle is required"),
  driver: yup.string().required("Driver is required"),
  destination_branch: yup.string().required("Destination is required"),
  freight: yup.number().nullable().optional(),
  advance: yup
    .number()
    .nullable()
    .optional()
    .test(
      "advance-not-greater-than-freight",
      "Advance cannot be greater than Freight",
      function (value) {
        const { freight } = this.parent;
        if (value == null || freight == null) return true;
        return value <= freight;
      }
    ),
});
let createManifestValidationForm = yup.object().shape({
  destination_branch: yup.string().required("Destination is required"),
});
let createDeliveryValidationFrom = yup.object().shape({
  driver: yup.string().required("Driver is required"),
});
let vehicleValidationForm = yup.object().shape({
  emergency_contact_number: yup
    .string()
    .required("Emergency Contact Number is required"),
  license_number: yup.string().required("License Number is required"),
});
let createRiderValidationForm = yup.object().shape({
  username: yup.string().required("Username is required"),
  full_name: yup.string().required("Full Name is required"),
  mobile_number: yup.string().required("Mobile Number is required"),
  license_number: yup.string().required("License Number is required"),
  citizenship_number: yup.string().required("Citizenship Number is required"),
});
let orderRemarksValidationForm = yup.object().shape({
  comment: yup.string().required("Remarks is required"),
});
let createDarazOrderValidationForm = yup.object().shape({
  from_branch: yup.string().required("From branch is required"),
  destination: yup.string().required("Destination is required"),
  note: yup.string().nullable().optional(),
});
let EditDarazOrderValidationForm = yup.object().shape({
  from_branch: yup.string().required("From branch is required"),
  destination: yup.string().required("Destination is required"),
  items: yup
    .array()
    .of(
      yup.object().shape({
        description: yup.string().required("Product description is required"),
        product_type: yup.string().required("Product type is required"),
        piece: yup
          .number()
          .typeError("Piece must be a number")
          .required("Piece is required")
          .min(1, "Piece must be at least 1"),
        weight: yup
          .number()
          .typeError("Weight must be a number")
          .required("Weight is required")
          .min(0, "Weight cannot be negative"),
      })
    )
    .min(1, "At least one item is required"),
  note: yup.string().nullable().optional(),
});
const emailDownloadValidationForm = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  date_range: yup.string().required("Date range is required"),
});
const deliveryformValidation = yup.object().shape({
  full_name: yup.string().required("Full Name is required"),
  primary_contact: yup
    .string()
    .required("Phone Number is required")
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "") return true;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch {
        return false;
      }
    }),
  signature: yup
    .mixed<File>()
    .required("Signature is required")
    .test("file-exists", "Signature is required", (value) => {
      return value instanceof File;
    }),
});
export {
  createRunsheetValidationForm,
  vehicleValidationForm,
  createRiderValidationForm,
  orderRemarksValidationForm,
  createManifestValidationForm,
  createDeliveryValidationFrom,
  createDarazOrderValidationForm,
  EditDarazOrderValidationForm,
  emailDownloadValidationForm,
  deliveryformValidation
};
